import { useQuery } from '@tanstack/react-query';
import { http } from 'services/http';
import type { TClientDocumentRes } from 'api/swagger';
import { CLIENT_CARGO_DOCUMENTS_GET_MANY } from '../query-keys';

interface IParams {
  enabled: boolean;
}

export const useGetCargoDocuments = (cargoId: number, params: IParams) => {
  const { enabled } = params;
  return useQuery<TClientDocumentRes[]>({
    queryKey: [CLIENT_CARGO_DOCUMENTS_GET_MANY, { cargoId }],
    queryFn: async () => {
      const { data } = await http.get<TClientDocumentRes[]>(`client-office/v1/cargoes/${cargoId}/documents`);

      return data;
    },
    retry: false,
    refetchOnWindowFocus: false,
    cacheTime: 30 * 1000,
    enabled,
  });
};
